export default __webpack_public_path__ + "static/media/eor_alone.532f9b59.png";